module.exports = __webpack_public_path__ + "fonts/NHaasGroteskTXPro-65Md.3be2963.eot";